import React from 'react';

interface ChatMessageProps {
    role: 'user' | 'assistant' | 'system';
    content: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ role, content }) => {
    if (role === 'system') return null;

    return (
        <div className={`ce-chat-msg ce-chat-msg--${role}`}>
            <div className="ce-chat-msg__avatar">
                {role === 'assistant' ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <circle cx="8" cy="8" r="6" />
                        <path d="M5.5 6.5h.01M10.5 6.5h.01M6 10c.5.5 1.5 1 2 1s1.5-.5 2-1" />
                    </svg>
                ) : (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <circle cx="8" cy="5.5" r="3" />
                        <path d="M2.5 14c0-3 2.5-4.5 5.5-4.5s5.5 1.5 5.5 4.5" />
                    </svg>
                )}
            </div>
            <div className="ce-chat-msg__content">
                <pre className="ce-chat-msg__text">{content}</pre>
            </div>
        </div>
    );
};

export default ChatMessage;
